import Vue from "vue";
import Router from "vue-router";
import Search from "./views/Search.vue";
import JwtService from "@/common/jwt.service";
import AgentService from "@/common/agent.service";
import ApiService from "@/common/api.service";
import store from "./store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "device-list",
      component: Search
    },
    {
      path: "/home",
      name: "home",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Home.vue")
    },
    {
      path: "/network",
      name: "network",
      component: () => import("./views/Network.vue")
    },
    {
      path: "/cabled",
      name: "cabled",
      component: () => import("./components/NetworkEth0.vue")
    },
    {
      path: "/wireless",
      name: "wireless",
      component: () => import("./components/NetworkWlan0.vue")
    },
    {
      path: "/login",
      name: "login",

      component: () => import("./views/Login.vue")
    },
    {
      path: "/logout",
      name: "logout",
      component: () => import("./views/Logout.vue")
    },
    {
      path: "/update",
      name: "update",
      component: () => import("./views/Update.vue")
    },
    { path: "/duo", name: "duo", component: () => import("./views/Duo.vue") },
    {
      path: "/units",
      name: "units",
      component: () => import("./views/DuoUnitsView.vue")
    },
    {
      path: "/features",
      name: "features",
      component: () => import("./views/DuoFeatures.vue")
    },
    {
      path: "/duo/settings",
      name: "duo/settings",
      component: () => import("./components/DuoSettings.vue")
    },
    {
      path: "/help",
      name: "help",
      component: () => import("./views/Help.vue")
    },
    {
      path: "/others",
      name: "others",
      component: () => import("./components/SystemPassword.vue")
    },
    {
      path: "/audio",
      name: "audio",
      component: () => import("./components/Audio.vue")
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ["/logout", "/login", "/help", "/", "/language"];
  const authRequired = !publicPages.includes(to.path);
  const agentRequired = to.path == "/login";
  const loggedIn = localStorage.getItem("user");
  const agent = AgentService.getAgent();
  store.dispatch("gateways/setCurrent", agent);
  if (agentRequired) {
    if (!agent) {
      next("/");
      return;
    }
  }
  console.log("router from " + from.path + " to " + to.path);

  /*
  if (authRequired) {
    Promise.all([store.dispatch("auth/check")])
    .then((result) => {
      console.log("Success check auth", result)
      next()
    }).catch((error) => {
      console.log("Failed check auth", error)
      console.log(error)
      next('/login')
    });
  }else {
    next();
  }
  */
  await store
    .dispatch("auth/check")
    .then(result => {
      console.log("Success check auth", result);
      next();
    })
    .catch(error => {
      if (authRequired) {
        console.log("Failed check auth", error);
        console.log(error);
        next("/");
      } else next();
    });
});

export default router;
